<template lang="html">
  <div class="result-button">
    <div class="result-button-main">
      <ui-button class="result-button-box" @click.native="$emit('click')">
        <slot></slot>
      </ui-button>
    </div>
    <div class="result-button-holder"></div>
  </div>
</template>

<script>
import UiButton from '../UI/Button.vue'

export default {
  name: 'ResultButton',

  components: {
    UiButton
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.result-button {
  $h: 118;
  &-main {
    @include fixed('blw');
    height: use($h);
    background-color: #fff;
    border-top: 1px solid #E4E4E4;
    @include center-box();
  }
  &-box {
    width: use(650);
  }
  &-holder {
    height: use($h);
  }
}
</style>
